import { ref } from 'vue';

function useFunnel() {
  const config = useRuntimeConfig();

  const dc_activar_funnel = ref(config.public.activarFunnel || 'SI');

  // Variable para almacenar el ID del funnel (usando localStorage para persistencia)
  const STORAGE_KEY = 'funnel_id';

  // Función para obtener el ID del funnel (desde localStorage si existe)
  function getFunnelId() {
    let valor = localStorage.getItem(STORAGE_KEY);
    //console.log('getFunnelId() valor: ', valor);
    return valor;
  }

  // Función para establecer el ID del funnel (guardándolo en localStorage)
  function setFunnelId(id) {
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  // Función para obtener el ID de una vista según ruta y negocio
  async function obtenerVistaId(vista_ruta, negocio_id) {
    try {
      if (dc_activar_funnel.value === 'NO') {
        //console.log('EL FUNNEL NO ESTA ACTIVO');
        return 'no activo';
      }

      //console.log('() para vista_ruta/negocioId:', vista_ruta, negocio_id);

      // Usar $fetch para llamar al endpoint del servidor Nuxt
      const response = await $fetch('/api/funnel', {
        method: 'GET',
        params: {
          action: 'obtenerVistaId',
          vista_ruta: vista_ruta,
          negocio_id: negocio_id,
        }
      });

      //console.log(' response:', response);

      if (response.success) {
        //console.log(' -> Vista encontrada con ID:', response.id);
        return response.id;
      } else {
        console.error('Error al obtener ID de vista:', response.message);
        return null;
      }
    } catch (err) {
      console.error('Error en la petición para obtener ID de vista:', err);
      return null;
    }
  }

  // Registrar un nuevo funnel
  async function RegistrarFunnel(usuario_uuid, finalizar, local_id) {
    try {
      //console.log('dc_activar_funnel.value: ', dc_activar_funnel.value);
      if (dc_activar_funnel.value === 'NO') {
        //console.log('EL FUNNEL NO ESTA ACTIVO');
        return 'no activo';
      }

      //console.log('RegistrarFunnel');

      const response = await $fetch('/api/funnel', {
        method: 'POST',
        body: {
          action: 'registrarFunnel',
          usuario_uuid: usuario_uuid,
          funnel_finalizado: finalizar,
          local_id: local_id
        }
      });

      //console.log('RegistrarFunnel response:', response);

      if (response.success) {
        //console.log('RegistrarFunnel -> Funnel registrado con ID data: ', response.funnel_id);
        setFunnelId(response.funnel_id);

        return response.funnel_id;
      } else {
        console.error('Error al registrar funnel:', response.message);
        return null;
      }
    } catch (err) {
      console.error('Error en la petición:', err);
      return null;
    }
  }

  // Registrar una vista visitada
  async function registrarVistaVisitada(vista_id) {
    //console.log('rvv, vista_id: ', vista_id);
    if (dc_activar_funnel.value === 'NO') {
      //console.log('rvv, EL FUNNEL NO ESTA ACTIVO');
      return 'no activo';
    }

    const funnelId = getFunnelId();
    //console.log('rvv, funnelId: ', funnelId);

    if (!funnelId) {
      console.error('rvv, No hay un funnel activo');
      return false;
    }

    try {
      const response = await $fetch('/api/funnel', {
        method: 'POST',
        body: {
          action: 'registrarVistaVisitada',
          funnel_id: funnelId,
          vista_id: vista_id
        }
      });

      //console.log('rvv, response:', response);

      if (response.success) {
        //console.log('rvv, Vista registrada correctamente:', vista_id);
        return true;
      } else {
        console.error('rvv, Error al registrar vista:', response.message);
        return false;
      }
    } catch (err) {
      console.error('rvv, Error en la petición:', err);
      return false;
    }
  }

  // Finalizar el funnel
  async function finalizarFunnel() {
    if (dc_activar_funnel.value === 'NO') {
      //console.log('EL FUNNEL NO ESTA ACTIVO');
      return 'no activo';
    }

    const funnelId = getFunnelId();
    //console.log('finalizarFunnel -> funnelId:', funnelId);

    if (!funnelId) {
      console.error('No hay un funnel activo para finalizar');
      return false;
    }

    try {
      const response = await $fetch('/api/funnel', {
        method: 'POST',
        body: {
          action: 'finalizarFunnel',
          funnel_id: funnelId,
          funnel_finalizado: 'si'
        }
      });

      //console.log('finalizarFunnel response:', response);

      if (response.success) {
        // Limpiamos el ID del funnel al finalizar
        setFunnelId(null);
        //console.log('Funnel finalizado correctamente');
        return true;
      } else {
        console.error('Error al finalizar funnel:', response.message);
        return false;
      }
    } catch (err) {
      console.error('Error en la petición:', err);
      return false;
    }
  }

  async function asignarLocalAFunnel(local_id) {
    try {
      if (dc_activar_funnel.value === 'NO') {
        //console.log('EL FUNNEL NO ESTA ACTIVO');
        return 'no activo';
      }

      //console.log('asignarLocalAFunnel');
      const funnelId = getFunnelId();

      if (!funnelId) {
        console.error('No hay un funnel activo para asignar local');
        return false;
      }

      //console.log('asignarLocalAFunnel -> funnelId/local_id:', funnelId, local_id);

      const response = await $fetch('/api/funnel', {
        method: 'POST',
        body: {
          action: 'asignarLocalAFunnel',
          funnel_id: funnelId,
          local_id: local_id
        }
      });

      //console.log('asignarLocalAFunnel response:', response);

      if (response.success) {
        //console.log('Local asignado correctamente al funnel');
        return true;
      } else {
        console.error('Error al asignar local al funnel:', response.message);
        return false;
      }
    } catch (err) {
      console.error('Error en la petición:', err);
      return false;
    }
  }

  // Devolver un objeto con las funciones y estado
  return {
    RegistrarFunnel,
    registrarVistaVisitada,
    finalizarFunnel,
    asignarLocalAFunnel,
    obtenerVistaId,
  };
}

// Exportamos una única instancia del funnel para compartir entre componentes
export default useFunnel;
